import React, { useState, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, Button, Form, FormGroup, Label, Input, Col, Row, FormFeedback } from "reactstrap";
import toast from "react-hot-toast";
import useApi from "common/ApiMiddlewere";

const EmployeeAdvanceModal = ({ modal, toggle, isEdit, EmpAdvanceListApi, editData }) => {
    const { postApi, getApi } = useApi();
    const [users, setUsers] = useState([]);
    const [userId, setUserId] = useState(editData?.AttendanceUserId || 0);
    const [loading, setLoading] = useState(false);
    const [remark, setRemark] = useState(editData?.Remarks || '');
    const [screenLoad, setScreenLoad] = useState(false)
    const [totalPayAdvance, setTotalPayAdvance] = useState(0)
    const [payAdvance, setPayAdvance] = useState(editData?.IsPayToEmp ? editData?.Advance : 0)
    const [returnAdvance, setReturnAdvance] = useState(editData?.IsPayToEmp ? 0 : editData?.Advance)
    const [isAdvancePaid, setIsAdvancePaid] = useState()

    useEffect(() => {
        getApi('Attendance/user-lookup').then(({ data, status }) => {
            if (status === 200) {
                setUsers(data);
                const filtered = data.filter(user => parseInt(user.Value2) == (JSON.parse(localStorage.getItem("authUser")).Id));
                setUserId(isEdit ? editData?.AttendanceUserId : filtered[0]?.Key || 0);
            } else {
                toast.error(data, { style: { fontSize: "15px" } });
            }
        });
    }, []);

    useEffect(() => {
        if (userId > 0) {
            setScreenLoad(true)
            postApi("Attendance/emp-salary-details", {
                AttendanceUserId: parseInt(userId),
                MonthOfSalary: new Date(),
            }).then(({ data, status }) => {
                setScreenLoad(false)
                if (status === 200) {
                    setTotalPayAdvance((data[0]?.TotalPayAdvance || 0))
                } else {
                    toast.error(data, { style: { fontSize: "15px" } });
                }
                setLoading(false);
            });
        }
    }, [userId])

    const handleSubmit = () => {
        if (userId > 0) {
            if (!isAdvancePaid) {
                setLoading(true)
                postApi("Attendance/emp-advance-add-edit", {
                    Id: editData ? editData.Id : 0,
                    AttendanceUserId: parseInt(userId),
                    isPayToEmp: parseFloat(payAdvance) > 0 ? true : false,
                    advance: parseFloat(payAdvance) > 0 ? parseFloat(payAdvance || 0) : parseFloat(returnAdvance || 0),
                    remarks: remark
                }).then(({ data, status }) => {
                    setLoading(false)
                    if (status === 200) {
                        toggle()
                        toast.success(isEdit ? "Successfully Updated" : "Successfully Added", { style: { fontSize: "15px" } });
                    } else {
                        toast.error(data, { style: { fontSize: "15px" } });
                    }
                    setLoading(false);
                    setUserId(0),
                        setPayAdvance(0)
                    setReturnAdvance(0)
                    setIsAdvancePaid(false)
                    toggle()
                    if (EmpAdvanceListApi != '') {
                        EmpAdvanceListApi()
                    }
                });
            }
        } else {
            toast.error("Please select employee", { style: { fontSize: "15px" } });
        }
    };

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    const handleReturnAdvance = (returnAdvance) => {
        setReturnAdvance(parseFloat(returnAdvance) || 0)
        setPayAdvance(0)
        if (parseFloat(returnAdvance) > (totalPayAdvance - (editData?.Advance || 0))) {
            setIsAdvancePaid(true)
        } else {
            setIsAdvancePaid(false)
        }
    }

    const handlePayAdvance = (payAdvance) => {
        setPayAdvance(parseFloat(payAdvance) || 0)
        setReturnAdvance(0)
        setIsAdvancePaid(false)
    }

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    {screenLoad && (
                        <div className="loading-overlay is-active">
                            <span className="fas fa-spinner fa-3x fa-spin"></span>
                        </div>
                    )}
                    <Modal isOpen={modal} toggle={toggle} centered={true} size="defualt" style={{ width: "350px" }}>
                        <div className="modal-content">
                            <ModalHeader className="text-centre" toggle={toggle} tag="h5">
                                <span> {isEdit ? "Update Advance" : "Add Advance"} </span>
                            </ModalHeader>
                            <ModalBody>
                                <React.Fragment>
                                    <Form>
                                        <Row className="mb-3">
                                            <Col md={12}>
                                                <Label for="userId" className="form-label">Employee</Label>
                                                <Input
                                                    type="select"
                                                    id="validationCustom01"
                                                    className="form-control-sm"
                                                    name="user"
                                                    bsSize="sm"
                                                    onChange={e => {
                                                        setUserId(e.target.value)
                                                    }}
                                                    value={userId}
                                                >
                                                    <option value={0}>Select Employee</option>
                                                    {users.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.Key}>
                                                                {item.Value}
                                                            </option>
                                                        )
                                                    })}
                                                </Input>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Label className="form-label">Total Advance:
                                                <span style={{ color: "blue" }}>
                                                    <i className="mdi mdi-currency-inr"></i>
                                                    {new Intl.NumberFormat('en-IN', {
                                                        currency: 'INR',
                                                        minimumFractionDigits: 2,
                                                    }).format(editData?.IsPayToEmp == true ? (totalPayAdvance - (editData?.Advance || 0)) : (totalPayAdvance - (editData?.Advance || 0)))}
                                                </span></Label>
                                        </Row>
                                        <Row className="mt-1 mb-3">
                                            <Col md={6}>
                                                <Label for="payAdvance" className="form-label">Pay Advance</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="0"
                                                    id="payAdvance"
                                                    className="form-control form-control-sm"
                                                    name="payAdvance"
                                                    onKeyPress={handleKeyPress}
                                                    value={payAdvance}
                                                    onChange={e => handlePayAdvance(e.target.value)}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Label for="returnAdvance" className="form-label">Return Advance</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="0"
                                                    id="returnAdvance"
                                                    className="form-control form-control-sm"
                                                    name="returnAdvance"
                                                    onKeyPress={handleKeyPress}
                                                    value={returnAdvance}
                                                    onChange={e => handleReturnAdvance(e.target.value)}
                                                    invalid={isAdvancePaid}
                                                />
                                                {isAdvancePaid &&
                                                    <FormFeedback type="invalid">
                                                        advance cannot be greater than pay advance.
                                                    </FormFeedback>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label for="remark" className="form-label">Remarks</Label>
                                                    <Input
                                                        type="textarea"
                                                        placeholder="Enter remark here"
                                                        rows='3'
                                                        id="Remarks"
                                                        className="form-control form-control-sm"
                                                        name="Remarks"
                                                        value={remark}
                                                        onChange={e => setRemark(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <div className="text-end">
                                            {loading ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    color="secondary"
                                                >
                                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                                    Loading
                                                </button>
                                            ) : (
                                                <Button
                                                    user="primary"
                                                    className="btn btn-primary btn-sm "
                                                    type="button"
                                                    color="primary"
                                                    onClick={() => handleSubmit()}
                                                >
                                                    Submit
                                                </Button>
                                            )}
                                        </div>
                                    </Form>
                                </React.Fragment >
                            </ModalBody>
                        </div>
                    </Modal >
                </div>
            </div >
        </>
    );
}

export default EmployeeAdvanceModal;
